<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import { noderedInstances } from '@/assets/nodered.instances';

@Component({})
export default class NodeRedManagement extends Vue {
  private loading = false;
  private nodeRedInstances: { id: number; name: string; domainName: string; }[] = [];
  private headers = [
    { title: 'Name', value: 'name', width: '30%' },
    { title: 'Domain name', value: 'domainName', width: '50%' },
    { title: '', value: 'actions', sortable: false, width: '20%' },
  ];

  private mounted() {
    this.nodeRedInstances = noderedInstances;
  }
}
</script>

<template>

  <div v-if="!$route.params.id">
    <v-row justify="space-between" align="center" dense>
      <v-col cols="12">
        <v-row align="center" dense>
          <v-col cols="12">
            <v-card color="#F4F4F4" variant="flat" class="pa-2" height="48">
              <v-row dense align="center">
                <v-col cols="6" md="8">
                  <v-row no-gutters align="center">
                    <v-col cols="4" md="auto">
<!--                      <v-btn size="small" variant="plain" :disabled="!selectedUsers.length" color="primary" @click="removeUser">
                        {{ mdAndUp ? 'Remove user' : 'Remove' }}
                      </v-btn>-->
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
    <v-data-table
        :sort-by="[{key: 'name', order: 'asc'}]"
        :items="nodeRedInstances"
        :headers="headers"
        fixed-header
        return-object
        height="calc(100vh - 260px)"
        items-per-page="25"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu>
          <template #activator="{ props }">
            <div class="d-flex justify-end">
              <v-btn v-bind="props" size="32" icon variant="flat" color="primary"><v-icon size="20">mdi-dots-vertical</v-icon></v-btn>
            </div>
          </template>
          <v-list density="compact">
            <v-list-item :to="`/admin/nodered/${item.id}`" prepend-icon="mdi-pencil" title="Edit Node-RED instance"></v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
  <router-view v-else></router-view>
</template>

<style scoped>

</style>